/*
 * @Date: 2023-11-01 13:37:21
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2023-11-01 14:36:34
 * @FilePath: \nicee-web-tw\src\components\VoiceRoom\voiceRoomEventBus.js
 * @Description: 语音房事件总线
 */
import EventEmitter from 'eventemitter3';

// 创建全局的 EventEmitter 实例
const VoiceRoomEventEmitter = new EventEmitter();

// 导出全局的 voiceRoomEventEmitter 实例
export default VoiceRoomEventEmitter;
